const SELECTOR =
  '[data-ch-deferred-accelerated-checkout]:not([data-ch-deferred-accelerated-checkout-loaded="true"])';
const DEFAULT_ROOT_MARGIN = '600px 0px';
const IDLE_TIMEOUT = 1800;

const observers = new Map();

function runWhenIdle(callback) {
  const requestIdleCallback = window.requestIdleCallback || ((run) => window.setTimeout(run, 1));
  requestIdleCallback(callback, { timeout: IDLE_TIMEOUT });
}

function mountPaymentButton(container) {
  if (!(container instanceof HTMLElement) || container.dataset.chDeferredAcceleratedCheckoutLoaded === 'true') return;

  const template = container.querySelector('template[data-ch-deferred-accelerated-checkout-template]');
  if (!(template instanceof HTMLTemplateElement)) return;

  container.dataset.chDeferredAcceleratedCheckoutLoaded = 'true';
  container.append(template.content.cloneNode(true));
  template.remove();
}

function getObserver(rootMargin) {
  if (observers.has(rootMargin)) return observers.get(rootMargin);

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        mountPaymentButton(entry.target);
      });
    },
    { rootMargin },
  );

  observers.set(rootMargin, observer);
  return observer;
}

function observeOrMount(container) {
  if (!(container instanceof HTMLElement)) return;

  if (!('IntersectionObserver' in window)) {
    mountPaymentButton(container);
    return;
  }

  const rootMargin = container.dataset.chDeferredRootMargin || DEFAULT_ROOT_MARGIN;
  getObserver(rootMargin).observe(container);
}

function deferContainer(container) {
  if (!(container instanceof HTMLElement)) return;

  const start = () => runWhenIdle(() => observeOrMount(container));

  if (document.readyState === 'complete') {
    start();
    return;
  }

  window.addEventListener('load', start, { once: true });
}

function hydrateDeferredAcceleratedCheckout(root = document) {
  root.querySelectorAll?.(SELECTOR).forEach(deferContainer);
}

hydrateDeferredAcceleratedCheckout();

document.addEventListener('shopify:section:load', (event) => {
  if (!(event.target instanceof Element)) return;
  hydrateDeferredAcceleratedCheckout(event.target);
});
